import SpriteSymbol from "svg-baker-runtime/browser-symbol";
import sprite from "svg-sprite-loader/runtime/browser-sprite.build";
var symbol = new SpriteSymbol({
  "id": "email.icon",
  "use": "email.icon-usage",
  "viewBox": "0 0 512 512",
  "content": "<symbol xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 512 512\" id=\"email.icon\"><path d=\"M448 384L448 141.8 316.9 241.6 385 319 383 321 304.1 251.4 256 288 207.9 251.4 129 321 127 319 195 241.6 64 142 64 384z\" /><path d=\"M439.7 128L72 128 256 267.9z\" /></symbol>"
});
var result = sprite.add(symbol);
export default symbol


//////////////////
// WEBPACK FOOTER
// ./src/assets/icons/email.icon.svg
// module id = 0Vyd
// module chunks = 13